import { OPEN_NAVBAR, SET_OPEN_NAVBAR } from "../actions/types";

const initialState = {
  isOpen: false,
};

const navbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_NAVBAR:
      return {
        ...state,
        isOpen: true,
      };
    case SET_OPEN_NAVBAR:
      return {
        ...state,
        isOpen: action.payload,
      };
    default:
      return state;
  }
};

export default navbarReducer;
